import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class DossierService {
    static getDossiers(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`dossiers?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.dossier.startDate = parseDate(x.dossier.startDate);
                x.dossier.effectDate = parseDate(x.dossier.effectDate);
                x.dossier.deadlineDate = parseDate(x.dossier.deadlineDate);
                x.dossier.endDate = !!x.dossier.endDate ? parseDate(x.dossier.endDate) : null;
            });
            return w;
        })));
    }
    static fetchDossier(oid) {
        return lastValueFrom(BaseService.get(`dossiers/${oid}`).pipe(map(x => {
            x.payload.startDate = parseDate(x.payload.startDate);
            x.payload.effectDate = parseDate(x.payload.effectDate);
            x.payload.deadlineDate = parseDate(x.payload.deadlineDate);
            x.payload.endDate = !!x.payload.endDate ? parseDate(x.payload.endDate) : null;
            return x;
        })));
    }
    static saveDossier(dto) {
        return lastValueFrom(BaseService.save(`dossiers`, dto));
    }
    static deleteDossier(oid) {
        return lastValueFrom(BaseService.delete(`dossiers/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Stats
    // ----------------------------------------------------------------------
    static fetchDossierStats(oid) {
        return lastValueFrom(BaseService.get(`dossiers-stats/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchDossierCombo(customerId, selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`dossiers-combo/${customerId}/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Dossier Years Range
    // ----------------------------------------------------------------------
    static getDossierYearsRange() {
        return lastValueFrom(BaseService.get(`dossiers-years-range`));
    }
    // ----------------------------------------------------------------------
    // Bulk Invoice Status
    // ----------------------------------------------------------------------
    static bulkChangeDossierInvoiceStatus(dossierId, status) {
        return lastValueFrom(BaseService.post(`dossier-bulk-invoice-status/${dossierId}/${status}`, {}));
    }
}
